import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from 'react-router-dom';
import PropTypes from "prop-types";
import Spinner from "../common/Spinner";
import UserAvatar from 'react-user-avatar';
import * as apiConfig from "../../api/config";
import { searchUsers } from "../../redux/actions/groupActions";
import AddGroupMemberControl from "./AddGroupMemberControl";

function SearchForNewGroupMembers({
    group,
    searchUsers,
    onMemberAdded
}) {

    const [processing, setProcessing] = useState(false);
    const [searchString, setSearchString] = useState("");
    const [searchMessage, setSearchMessage] = useState("Enter a users name or email address to search");
    const [results, setResults] = useState([]);

    useEffect(() => {


    }, [])

    function handleSearch(e) {
        e.preventDefault();
        if (searchString == null || searchString == "") {
            setResults([]);
            return;
        }
        setProcessing(true);
        searchUsers(searchString, group.id)
            .then(results => {
                setResults(results)
                setSearchMessage(`${results.length} Result${results.length == 1 ? "" : "s"}`)
                setProcessing(false);
            });
    }

    function handleSearchChange(e) {
        var search = e.target.value
        setSearchString(search);
        if (search == null || search == "") {
            setResults([]);
        }
    }

    function onUserAddedToGroup() {
        setResults([]);
        onMemberAdded(); 
    }

    return (

        <React.Fragment>
            <div className="add-user-search col-12">
                <div className="tab-header search-toolbar col-md-12 col-lg-12">
                    <div className="row">
                        <div className="col-sm-6 col-md-6  col-lg-6 my-2" >
                            <form onSubmit={handleSearch} >
                                <div className="input-group float-right">
                                    <input type="text" className="form-control form-control-sm" value={searchString} onChange={handleSearchChange} placeholder="Search for a user..." aria-label="Keyword Search" />
                                    <div className="input-group-append">
                                        <button type="submit" className="btn btn-secondary btn-sm" type="submit"><span className="fas fa-search" onClick={handleSearch}></span></button>
                                    </div>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
                <div className="users col-12 mt-3">
                    {processing ? <Spinner /> :
                        <React.Fragment>
                            <p className="col-11">{searchString == null || searchString == "" ? "Enter a users name or email address to search" : searchMessage}</p>
                            <div className="row justify-content-md-center mt-3">
                                <table className="table col-11">
                                    <tbody>
                                        {
                                            results.map((resultingUser, index) => {
                                                return (
                                                    <tr key={resultingUser.userId}>
                                                        <td width="35px" scope="row"><UserAvatar size="35" name={`${resultingUser.firstName} ${resultingUser.surname}`} src={resultingUser.hasAvatar ? `${apiConfig.API_URL}user/avatar/${resultingUser.userId}.png` : ""} /></td>
                                                        <td><Link to={"/user/profile/" + resultingUser.userId}>{`${resultingUser.firstName} ${resultingUser.surname}`}</Link></td>
                                                        <td width="20px" >
                                                            <AddGroupMemberControl subjectUser={resultingUser} group={group} onUserAdded={onUserAddedToGroup} />
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                    </tbody>
                                </table>
                            </div>
                        </React.Fragment>
                    }
                </div>
            </div>
        </React.Fragment>
    );
};

SearchForNewGroupMembers.propTypes = {
    group: PropTypes.object.isRequired,
    searchUsers: PropTypes.func.isRequired
}

function mapStateToProps(state) {
    return {
    }
}

const mapDispatchToProps = {
    searchUsers
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchForNewGroupMembers);


// WEBPACK FOOTER //
// ./src/components/groups/SearchForNewGroupMembers.js